export const EVENT_NAME = {
  PAGEVIEW: 'PAGEVIEW',
  ACCOUNTCREATE: 'ACCOUNT_CREATE',
  LOGIN: 'LOGIN',
  QRV_FAILURE: 'QRV_FAILURE',
  PHONE_NUMBER_ERROR: 'PHONE_NUMBER_ERROR',
  VERIFICATION_CODE_ERROR: 'VERIFICATION_CODE_ERROR',
  PHONE_ALREADY_ASSOCIATED_ERROR: 'PHONE_ALREADY_ASSOCIATED_ERROR',
  ACCOUNT_UPDATE: 'ACCOUNT_UPDATE',
  FORM_SUBMIT: 'FORM_SUBMIT',
};

export const FORM_NAME = {
  CHANGE_PASSWORD: 'Change Password',
  ACTIVATE_ONLINE_ACCOUNT: 'Activate Online Account',
  FORGOT_PASSWORD: 'Forgot Password',
  ENROLLMENT_CONFIRM_IDENTITY: 'Enrollment|Confirm Identity',
};

export const ACDL_EVENT_VALUES = {
  AUTHENTICATION: 'authentication',
  SUCCESS: 'success',
  FAILURE: 'failure',
  AUTHENTICATED: 'authenticated',
  UNAUTHENTICATED: 'unauthenticated',
};
